// Visual mega menu, style C: hovering or focusing a group on the left shows its subcategory tiles.
if (!customElements.get("mega-visual-rail")) {
  customElements.define(
    "mega-visual-rail",
    class MegaVisualRail extends HTMLElement {
      connectedCallback() {
        this.links = [...this.querySelectorAll("[data-mega-panel]")];
        this.links.forEach((link) => {
          link.addEventListener("mouseenter", () => this.activate(link));
          link.addEventListener("focus", () => this.activate(link));
        });
        // Photos of the hidden panels are lazy, and a lazy image inside display:none is never fetched until
        // its panel shows, so moving along the rail used to wait for each panel's photos (owner report,
        // 2026-10-29). As soon as the top-level item is hovered or focused, every photo of this menu starts
        // downloading, so the panels are ready by the time the pointer reaches them.
        const menu = this.closest(".has-sub-menu") || this.parentElement;
        if (!menu) return;
        const preload = () => this.preload();
        menu.addEventListener("pointerenter", preload, { once: true });
        menu.addEventListener("focusin", preload, { once: true });
        // The markup may arrive while the pointer is already on the item (menu opened before the deferred fetch finished).
        try {
          if (menu.matches(":hover")) this.preload();
        } catch (error) {
          /* selector unsupported: the next hover preloads */
        }
      }

      preload() {
        this.querySelectorAll('img[loading="lazy"]').forEach((img) => img.setAttribute("loading", "eager"));
      }

      activate(link) {
        const id = link.dataset.megaPanel;
        this.links.forEach((item) => item.classList.toggle("is-active", item === link));
        this.querySelectorAll("[data-mega-panel-id]").forEach((panel) => {
          panel.classList.toggle("is-active", panel.dataset.megaPanelId === id);
        });
      }
    },
  );
}
